export default "__VITE_ASSET__DqNWukOF__"